<p-dropdown styleClass="w-full minclt-validity" [(ngModel)]="validity" [options]="validities" optionLabel="text"
  placeholder="Seleccione una opción" optionValue="value" (onChange)="onChangeValueOnSelect($event)">
</p-dropdown>